/* Olea PDP: countdown, gallery, bundle/subscription offer box */
(function () {
  if (window.__oleaPdp) return; window.__oleaPdp = true;
  var money = function (c) { return '$' + (c / 100).toFixed(2); };

  // Countdown to local midnight (a real daily deadline, not a fake reset timer)
  document.querySelectorAll('[data-olea-cd]').forEach(function (el) {
    var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    (function tick() {
      var now = new Date(), end = new Date(now); end.setHours(24, 0, 0, 0);
      var d = Math.max(0, Math.floor((end - now) / 1000));
      h.textContent = pad(Math.floor(d / 3600)); m.textContent = pad(Math.floor(d / 60) % 60); s.textContent = pad(d % 60);
      setTimeout(tick, 1000);
    })();
  });

  // Estimated delivery window: +N to +M business days
  function addBiz(n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; }
  function fmtDay(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  document.querySelectorAll('[data-olea-eta]').forEach(function (el) {
    var from = addBiz(parseInt(el.dataset.oleaEta, 10) || 4), to = el.dataset.oleaEtaTo ? addBiz(parseInt(el.dataset.oleaEtaTo, 10)) : null;
    el.textContent = to ? fmtDay(from) + ' – ' + fmtDay(to) : fmtDay(from);
  });

  document.querySelectorAll('[data-olea-gal]').forEach(function (g) {
    var main = g.querySelector('[data-main]'), thumbs = [].slice.call(g.querySelectorAll('[data-thumb]')), i = 0;
    function go(n) {
      if (!thumbs.length) return;
      i = (n + thumbs.length) % thumbs.length;
      main.src = thumbs[i].dataset.thumb;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var p = g.querySelector('[data-prev]'), nx = g.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(i - 1); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); });
  });

  document.querySelectorAll('[data-olea-buy]').forEach(function (root) { try {
    var cfg = JSON.parse(root.querySelector('[data-cfg]').textContent);
    var tiers = [].slice.call(root.querySelectorAll('[data-tier]'));
    var sub = !!cfg.planId, idx = Math.min(cfg.defaultTier || 0, tiers.length - 1);

    // price of tier k in current mode; tier discount is a fixed amount off (matches the automatic discounts)
    function unit() { return sub ? cfg.subUnit : cfg.oneUnit; }
    // Subscribe: 1 bottle on the plan (the only thing that renews, $39.99) + extra one-time bottles discounted by the tier's starter code.
    // One-time: the Supliful 2/3-pack bundle product at its own price.
    function price(k) {
      var t = cfg.tiers[k];
      if (sub) return t.qty > 1 ? cfg.subUnit + cfg.oneUnit * (t.qty - 1) - t.off : cfg.subUnit;
      return t.variantId ? t.one : cfg.oneUnit * t.qty - t.off;
    }
    function strike(k) {
      var t = cfg.tiers[k];
      return cfg.compareUnit * t.qty + (sub ? t.giftValue : 0);
    }
    function set(sel, txt) { root.querySelectorAll(sel).forEach(function (e) { e.textContent = txt; }); }

    function render() {
      root.classList.toggle('is-sub', sub);
      tiers.forEach(function (el, k) {
        el.classList.toggle('is-on', k === idx);
        el.setAttribute('aria-checked', k === idx);
        el.querySelector('[data-p]').textContent = money(price(k));
        el.querySelector('[data-c]').textContent = money(strike(k));
        el.querySelector('[data-save]').textContent = money(strike(k) - price(k));
        el.querySelectorAll('[data-sub-only]').forEach(function (x) { x.hidden = !sub; });
      });
      var t = cfg.tiers[idx];
      set('[data-mode-label]', sub ? cfg.labels.sub : cfg.labels.one);
      set('[data-mode-price]', money(price(idx)));
      set('[data-mode-strike]', money(strike(idx)));
      set('[data-mode-save]', money(strike(idx) - price(idx)));
      set('[data-atc-p]', money(price(idx)));
      set('[data-atc-c]', money(strike(idx)));
      root.querySelectorAll('[data-gift]').forEach(function (g) {
        var need = g.dataset.gift, open = false;
        if (need === 'ship') open = sub || (cfg.freeShipTier >= 0 && idx >= cfg.freeShipTier);
        else open = sub && t.qty >= parseInt(need, 10);
        g.classList.toggle('is-locked', !open);
        g.querySelector('[data-gift-state]').textContent = open ? g.dataset.label : 'Locked';
      });
      root.querySelectorAll('[data-if-sub]').forEach(function (e) { e.hidden = !sub; });
      root.querySelectorAll('[data-if-one]').forEach(function (e) { e.hidden = sub; });
    }

    var gal = root.querySelector('[data-olea-gal] [data-main]');
    tiers.forEach(function (el, k) { el.addEventListener('click', function () {
      idx = k; render();
      if (gal && el.dataset.gallery) {
        gal.src = el.dataset.gallery;
        root.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-on'); });
      }
    }); });
    root.querySelectorAll('[data-swap]').forEach(function (b) {
      b.addEventListener('click', function () { if (cfg.planId) { sub = !sub; render(); } });
    });

    root.querySelector('[data-atc]').addEventListener('click', function () {
      var btn = this, err = root.querySelector('[data-err]'), t = cfg.tiers[idx];
      var line, items;
      if (sub) {
        line = { id: cfg.variantId, quantity: 1, selling_plan: cfg.planId };
        items = [line];
        if (t.qty > 1) items.push({ id: cfg.variantId, quantity: t.qty - 1 });
      } else {
        line = t.variantId ? { id: t.variantId, quantity: 1 } : { id: cfg.variantId, quantity: t.qty };
        items = [line];
      }
      if (sub && cfg.giftVariantId && t.qty >= cfg.giftMinQty) items.push({ id: cfg.giftVariantId, quantity: 1 });
      if (sub && cfg.gift2VariantId && t.qty >= cfg.gift2MinQty) items.push({ id: cfg.gift2VariantId, quantity: 1 });
      btn.disabled = true; err.textContent = '';
      var add = function (list) {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: list }) })
          .then(function (r) { return r.json().then(function (body) { if (!r.ok) { var e = new Error(body.description || body.message || 'Could not add to cart'); e.body = body; throw e; } return body; }); });
      };
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function () { return add(items); })
        .catch(function (e) {
          // a gift that can't be added should never block the sale: retry with just the bottles
          if (items.length > 1) { console.warn('[olea] gift add failed, retrying without gifts:', e.message); return fetch('/cart/clear.js', { method: 'POST' }).then(function () { return add(items.filter(function (i) { return i.id === cfg.variantId || i.id === t.variantId; })); }); }
          throw e;
        })
        .then(function () {
          if (!(sub && t.code)) return;
          return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: t.code }) });
        })
        .then(function () {
          var dest = cfg.goTo || '/checkout';
          if (sub && t.code) dest += (dest.indexOf('?') > -1 ? '&' : '?') + 'discount=' + encodeURIComponent(t.code);
          window.location.href = dest;
        })
        .catch(function (e) { console.error('[olea] add to cart failed', e.message, e.body); btn.disabled = false; err.textContent = e.message; });
    });

    render();
  } catch (e) { var x = root.querySelector('[data-err]'); if (x) x.textContent = 'Offer box error: ' + e.message; console.error(e); } });
})();
